module.exports = __webpack_public_path__ + "static/media/mePicture.3fe57f71.jpg";